module.exports = __webpack_public_path__ + "static/media/pause-icon.fe04451d.svg";